/**
 * Fetches an image from a URL and converts it to a Base64 string.
 * @param url The image URL to fetch.
 * @returns A Promise that resolves to the Base64 string.
 */
export const fetchImageAsBase64 = async (url: string): Promise<string> => {
    if (!url || !url.startsWith("http")) return url;

    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const blob = await response.blob();
        
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error("Erro ao converter URL para Base64:", error);
        // Retorna string vazia para forçar o fallback para a logo padrão no pdfMake
        return "";
    }
};
